import { fi, nb, sv } from "date-fns/locale";
import { format, formatDistanceToNow } from "date-fns";

const dateLocales: Record<string, object> = { sv, fi, nb };

const formatDate = (date: number | Date, dateFormat = "yyyy-MM-dd", locale = "sv_SE") => {
    if (!date) {
        return null;
    }

    const options: Record<string, unknown> = {};
    const isoLocale: string = (locale || "sv_SE").slice(0, 2);
    const dateLocale = dateLocales[isoLocale];
    if (dateLocale) {
        options["locale"] = dateLocale;
    }

    return format(date, dateFormat, options);
};

export const formatRelativeTime = (date: number | Date, locale = "sv_SE") => {
    if (!date) {
        return null;
    }
    const isoLocale: string = (locale || "sv_SE").slice(0, 2);
    const dateLocale = dateLocales[isoLocale];
    return formatDistanceToNow(date, {
        addSuffix: true,
        locale: dateLocale,
    });
};

export default formatDate;
